import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import MarkAsDoneButton from "./actions/MarkAsDoneButton";
import { QualityAlertButton } from "./actions/QualityAlertButton";
import { ScrapButton } from "./actions/ScrapButton";
import type IOdooOperationsService from "./erp/manufacturing/OdooOperationsService";
import type {
	ProductionOrder,
	QualityCheck,
} from "./erp/manufacturing/Product";
import {} from "./Plot/cloudApi";
import QualityCheckDockTest from "./quality_checks/QualityCheckDockTest";
import QualityCheckPassFail from "./quality_checks/QualityCheckPassFail";
import QualityCheckPrintLabel from "./quality_checks/QualityCheckPrintLabel";
import { QualityCheckTestCradle } from "./quality_checks/QualityCheckTestCradle";
import QualityCheckTestSensorDot from "./quality_checks/QualityCheckTestSensorDot";
import QualityCheckWriteNfcTag from "./quality_checks/QualityCheckWriteNfcTag";
import { isScrappableQualityCheck, qualityCheckCode } from "./Utils";
import {
	WI_CONFIGURE_ECG_DOTS,
	WI_CONFIGURE_ECG_DOTS_DUAL_CHANNEL,
	WI_CONFIGURE_ECG_DOTS_EPICARE,
	WI_CONFIGURE_EEG_DOTS,
	WI_CONFIGURE_EPICARE_FOCAL_BOX_DOTS,
	WI_DOCK_TEST,
	WI_DOT_SIGNAL_QUALITY,
	WI_PRINT_LABEL,
	WI_TEST_CRADLE_RESISTANCES,
	WI_WRITE_NFC_TAG,
} from "./WorkInstructions";

interface AssemblyStepProps {
	svc: IOdooOperationsService;
	qualityCheck: QualityCheck;
	productionOrder: ProductionOrder;
	onChange: (productionOrder: ProductionOrder) => void;
	onAlert(alertContent: string): void;
	onIsBusyChange: (isBusy: boolean) => void;
}
function AssemblyStep(props: AssemblyStepProps) {
	const {
		productionOrder,
		qualityCheck,
		svc,
		onChange,
		onAlert,
		onIsBusyChange,
	} = props;
	const [open, setOpen] = React.useState(false);
	const [messageSnackbar, setmessageSnackbar] = useState("");
	const [isBusy, setIsBusy] = useState(false);

	useEffect(() => {
		onIsBusyChange(isBusy);
	}, [isBusy, onIsBusyChange]);

	const handleSnackbar = (message: string) => {
		setmessageSnackbar(message);
		setOpen(true);
	};
	const handleClose = (event: any, reason: string) => {
		if (reason === "clickaway") {
			return;
		}

		setOpen(false);
	};

	const history = useHistory();

	return (
		<div
			style={{
				padding: 8,
				alignContent: "center",
				width: "100%",
				height: "100%",
			}}
		>
			{qualityCheckCode(qualityCheck) === WI_DOT_SIGNAL_QUALITY && (
				<QualityCheckTestSensorDot
					qualityCheck={qualityCheck}
					serial={productionOrder.finishedSerial}
					svc={svc}
					onError={(error) => {
						console.error("Failed to pass dot signal quality", error);
						handleSnackbar("Failed to pass dot signal quality");
					}}
					onSuccess={() => {
						onChange({
							...productionOrder,
							qualityChecks: [...productionOrder.qualityChecks],
						});
					}}
					onFail={() => {
						onChange({
							...productionOrder,
							qualityChecks: [...productionOrder.qualityChecks],
						});
					}}
					onIsBusyChange={setIsBusy}
				/>
			)}

			{qualityCheckCode(qualityCheck) === WI_DOCK_TEST && (
				<QualityCheckDockTest
					description="Test that all 5 slots can be used."
					qualityCheck={qualityCheck}
					serial={productionOrder.finishedSerial}
					minimumDots={5}
					removeFromGroupEnabled={true}
					svc={svc}
					group={{
						id: "4d0912f0-4443-11eb-b21a-59854bd51688",
						description: "manufacturing group",
						name: "1_Manufacturing_Dock",
					}}
					onError={(error) => {
						console.error("Failed to pass dock test", error);
						handleSnackbar("Failed to pass dock test");
					}}
					onSuccess={() => {
						onChange({ ...productionOrder });
					}}
					onFail={() => {
						onChange({ ...productionOrder });
					}}
					onIsBusyChange={setIsBusy}
				/>
			)}

			{qualityCheckCode(qualityCheck) === WI_PRINT_LABEL && (
				<QualityCheckPrintLabel
					qualityCheck={qualityCheck}
					serial={productionOrder.finishedSerial!}
					svc={props.svc}
					productionOrder={productionOrder}
					onError={(error) => {
						const msg = "Failed to print label";
						console.error(msg, error);
						handleSnackbar(`${msg}: ${error}`);
					}}
					onSuccess={() => {
						onChange({
							...productionOrder,
							qualityChecks: [...productionOrder.qualityChecks],
						});
					}}
					onFail={() => {
						onChange({
							...productionOrder,
							qualityChecks: [...productionOrder.qualityChecks],
						});
					}}
					onIsBusyChange={setIsBusy}
				/>
			)}

			{qualityCheckCode(qualityCheck) === WI_WRITE_NFC_TAG &&
				productionOrder.finishedSerial !== undefined && (
					<QualityCheckWriteNfcTag
						qualityCheck={qualityCheck}
						serial={productionOrder.finishedSerial}
						productionOrder={productionOrder}
						svc={svc}
						onError={(error) => {
							console.error("Failed to write NFC tag", error);
							handleSnackbar(`Failed to write NFC tag: ${error.message}`);
						}}
						onSuccess={() => {
							onChange({
								...productionOrder,
								qualityChecks: [...productionOrder.qualityChecks],
							});
						}}
						onFail={() => {
							onChange({
								...productionOrder,
								qualityChecks: [...productionOrder.qualityChecks],
							});
						}}
						onIsBusyChange={setIsBusy}
					/>
				)}

			{qualityCheckCode(qualityCheck) === WI_TEST_CRADLE_RESISTANCES && (
				<QualityCheckTestCradle
					qualityCheck={qualityCheck}
					svc={svc}
					onError={(error) => {
						handleSnackbar(error.message);
					}}
					onSuccess={() => {
						onChange({
							...productionOrder,
							qualityChecks: [...productionOrder.qualityChecks],
						});
					}}
					onFail={() => {
						onChange({
							...productionOrder,
							qualityChecks: [...productionOrder.qualityChecks],
						});
					}}
					onIsBusyChange={setIsBusy}
				/>
			)}

			{qualityCheckCode(qualityCheck) !== WI_DOT_SIGNAL_QUALITY &&
				qualityCheckCode(qualityCheck) !== WI_DOCK_TEST &&
				qualityCheckCode(qualityCheck) !== WI_CONFIGURE_ECG_DOTS_EPICARE &&
				qualityCheckCode(qualityCheck) !== WI_CONFIGURE_EEG_DOTS &&
				qualityCheckCode(qualityCheck) !== WI_CONFIGURE_ECG_DOTS_DUAL_CHANNEL &&
				qualityCheckCode(qualityCheck) !==
					WI_CONFIGURE_EPICARE_FOCAL_BOX_DOTS &&
				qualityCheckCode(qualityCheck) !== WI_CONFIGURE_ECG_DOTS &&
				qualityCheckCode(qualityCheck) !== WI_WRITE_NFC_TAG &&
				qualityCheckCode(qualityCheck) !== WI_TEST_CRADLE_RESISTANCES &&
				qualityCheckCode(qualityCheck) !== WI_PRINT_LABEL && (
					<QualityCheckPassFail
						qualityCheck={qualityCheck}
						svc={svc}
						onError={(error) => {
							console.error("Error", error);
							handleSnackbar(`Error: ${error}`);
						}}
						onSuccess={() => {
							onChange({
								...productionOrder,
								qualityChecks: [...productionOrder.qualityChecks],
							});
						}}
						onFail={() => {
							onChange({
								...productionOrder,
								qualityChecks: [...productionOrder.qualityChecks],
							});
						}}
						onIsBusyChange={setIsBusy}
					/>
				)}

			<Grid container spacing={1} style={{ padding: 20 }}>
				<Grid item xs={12}>
					&nbsp;
				</Grid>
				<Grid item xs={12}>
					&nbsp;
				</Grid>

				<Grid item xs={4}>
					<QualityAlertButton
						svc={svc}
						qualityCheck={qualityCheck}
						onClick={async () => {}}
						disabled={
							isBusy ||
							isScrappableQualityCheck(qualityCheck) ||
							productionOrder.state === "done" ||
							productionOrder.state === "cancel" ||
							qualityCheck.state !== "fail" ||
							!productionOrder?.finishedSerial?.id ||
							!productionOrder.qualityChecks.some(
								(qc) => qc.state === "fail",
							) ||
							!productionOrder.qualityChecks
								.filter((qc) =>
									[WI_WRITE_NFC_TAG, WI_PRINT_LABEL].includes(
										qualityCheckCode(qc),
									),
								)
								.every((qc) => qc.state && ["pass", "fail"].includes(qc.state))
						}
						onError={(error) => {
							console.error("Failed to create quality alert", error);
							handleSnackbar(`Failed to create quality alert: ${error}`);
						}}
						onDone={(qualityAlertRef: string) => {
							onAlert(qualityAlertRef);
						}}
					/>
				</Grid>
				<Grid item xs={4}>
					<ScrapButton
						svc={svc}
						qualityCheck={qualityCheck}
						onClick={async () => {}}
						disabled={
							isBusy ||
							!isScrappableQualityCheck(qualityCheck) ||
							productionOrder.state === "done" ||
							productionOrder.state === "cancel" ||
							qualityCheck.state !== "fail" ||
							!productionOrder?.finishedSerial?.id ||
							!productionOrder.qualityChecks.some(
								(qc) => qc.state === "fail",
							) ||
							!productionOrder.qualityChecks
								.filter((qc) =>
									[WI_WRITE_NFC_TAG, WI_PRINT_LABEL].includes(
										qualityCheckCode(qc),
									),
								)
								.every((qc) => qc.state && ["pass", "fail"].includes(qc.state))
						}
						onError={(error) => {
							console.error("Failed to scrap", error);
							handleSnackbar(`Failed to scrap: ${error}`);
						}}
						onDone={(scrapRef: string) => {
							onAlert(scrapRef);
						}}
					/>
				</Grid>
				<Grid item xs={4}>
					<MarkAsDoneButton
						svc={svc}
						productionOrder={productionOrder}
						onError={(error) => {
							console.error("Failed to mark as done", error);
							handleSnackbar(`Failed to mark as done: ${error}`);
						}}
						onDone={(po) => {
							onChange(po);
							history.push("/");
						}}
						disableButton={isBusy}
					/>
				</Grid>
			</Grid>
			<Snackbar
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				open={open}
				autoHideDuration={5000}
				onClose={handleClose}
				message={messageSnackbar}
				action={
					<React.Fragment>
						<Button
							color="secondary"
							size="small"
							onClick={(event) => {
								handleClose(event, "");
							}}
						>
							UNDO
						</Button>
					</React.Fragment>
				}
			/>
		</div>
	);
}

export default AssemblyStep;
